export const validateLengthCreditCard = (valueField: any, lengthCreditCard: any) => {
    if(valueField === lengthCreditCard){
        return true
    }
    return false
}